import {
  StyledContainer,
  StyledTopContainer,
  StyledHeader,
  StyledTitle,
} from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/Distributor/styled-components';
import DistributorCard from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/Distributor/DistributorCard'
import useDistributor from '@/containers/SubscriptionFormPageNew/Components/Distributor/useDistributor'

const DistributorContent = () => {
  const { t, eldElectricity, eldGas, eldWater } = useDistributor();
  return (
    <StyledContainer>
      <StyledTopContainer>
        <StyledHeader>
          <StyledTitle>{t('subscriptionForm:distributor.title')}</StyledTitle>
        </StyledHeader>
      </StyledTopContainer>

      <DistributorCard
        typeKey="common:energy_elec_long"
        data={eldElectricity}
        hidden={!eldElectricity.name}
      />

      <DistributorCard
        typeKey="common:energy_gas"
        data={eldGas}
        hidden={!eldGas.name}
      />

      <DistributorCard
        typeKey="common:water_text"
        data={eldWater}
        hidden={!eldWater.name}
      />
    </StyledContainer>
  );
}

export default DistributorContent;
